import { createAsyncThunk } from '@reduxjs/toolkit';

import type { InternalChatRespostaRapida } from '../../types';
import { respostasRapidasService } from './services';

const reject = (error: unknown): string =>
  error instanceof Error ? error.message : 'Erro desconhecido';

export const fetchRespostasRapidas = createAsyncThunk<
  InternalChatRespostaRapida[],
  void,
  { rejectValue: string }
>('chatAtendimento/respostasRapidas/fetch', async (_, { rejectWithValue }) => {
  try {
    const result = await respostasRapidasService.list();
    return result.items;
  } catch (error) {
    return rejectWithValue(reject(error));
  }
});

export const createRespostaRapida = createAsyncThunk<
  InternalChatRespostaRapida,
  { atalho: string; conteudo: string; compartilhada?: boolean },
  { rejectValue: string }
>('chatAtendimento/respostasRapidas/create', async (input, { rejectWithValue }) => {
  try {
    return await respostasRapidasService.create(input);
  } catch (error) {
    return rejectWithValue(reject(error));
  }
});

export const updateRespostaRapida = createAsyncThunk<
  InternalChatRespostaRapida,
  { respostaId: string; atalho?: string; conteudo?: string },
  { rejectValue: string }
>(
  'chatAtendimento/respostasRapidas/update',
  async ({ respostaId, ...rest }, { rejectWithValue }) => {
    try {
      return await respostasRapidasService.update(respostaId, rest);
    } catch (error) {
      return rejectWithValue(reject(error));
    }
  },
);

export const deleteRespostaRapida = createAsyncThunk<string, string, { rejectValue: string }>(
  'chatAtendimento/respostasRapidas/delete',
  async (respostaId, { rejectWithValue }) => {
    try {
      await respostasRapidasService.remove(respostaId);
      return respostaId;
    } catch (error) {
      return rejectWithValue(reject(error));
    }
  },
);
